import { render, staticRenderFns } from "./ColdCallObjection.vue?vue&type=template&id=28da072d"
import script from "./ColdCallObjection.vue?vue&type=script&lang=js"
export * from "./ColdCallObjection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports